module.exports = __webpack_public_path__ + "./favicons/apple-icon-114x114.png";